import { StandardEquipment } from 'types';

export const getUniqueStandardEquipments = (
	compareTo: StandardEquipment[],
	upgrade: StandardEquipment[]
): StandardEquipment[] =>
	upgrade.filter((a) => !compareTo.some((b) => a.descriptions[0] === b.descriptions[0]));
